var map = {
	"./0.1.0/reference.json": 652,
	"./0.10.0/reference.json": 653,
	"./0.14.0/reference.json": 654,
	"./0.15.0/reference.json": 655,
	"./0.16.0/reference.json": 656,
	"./0.17.0/reference.json": 657,
	"./0.18.0/reference.json": 658,
	"./0.19.0/reference.json": 659,
	"./0.2.0/reference.json": 660,
	"./0.20.0/reference.json": 661,
	"./0.21.0/reference.json": 662,
	"./0.22.0/reference.json": 663,
	"./0.23.0/reference.json": 664,
	"./0.26.0/reference.json": 665,
	"./0.27.0/reference.json": 666,
	"./0.29.0/reference.json": 667,
	"./0.3.0/reference.json": 668,
	"./0.33.0/reference.json": 669,
	"./0.34.0/reference.json": 670,
	"./0.37.0/reference.json": 671,
	"./0.37.1/reference.json": 672,
	"./0.38.0/reference.json": 673,
	"./0.4.0/reference.json": 674,
	"./0.40.0/reference.json": 675,
	"./0.41.0/reference.json": 676,
	"./0.43.0/reference.json": 677,
	"./0.44.0/reference.json": 678,
	"./0.47.0/reference.json": 679,
	"./0.51.0/reference.json": 680,
	"./0.52.0/reference.json": 681,
	"./0.54.0/reference.json": 682,
	"./0.55.0/reference.json": 683,
	"./0.55.1/reference.json": 684,
	"./0.58.1/reference.json": 685,
	"./0.59.3/reference.json": 686,
	"./0.59.4/reference.json": 687,
	"./0.6.0/reference.json": 688,
	"./0.7.0/reference.json": 689,
	"./0.9.0/reference.json": 690
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 651;


//////////////////
// WEBPACK FOOTER
// ./~/camshaft-reference/versions ^\.\/.*\/reference\.json$
// module id = 651
// module chunks = 0 1 2